// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__lzK-1","errors":"Errors_errors__29gwa"};